<div class="FacturasFrame">
    <iframe id="iframeTuf" class="FacturasIframe" name="centro"
        src="https://ventas.tufesa.com.mx/bolsaTrabajo/bienvenido" frameBorder="0"></iframe>
</div>